module.exports = __webpack_public_path__ + "img/mobile_number.d7baeca6.svg";